import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/users",
        name: "users",
        component: () => import("@/components/users/_Users.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.GetUserDetails,
            breadcrumbs: {
                icon: "profile-icon",
                paths: []
            },
            title: "navbar.users"
        }
    },
    {
        path: "/users/create",
        name: "createUser",
        component: () => import("@/components/users/_UserForm.vue"),
        props: true,
        meta: {
            breadcrumbs: {
                icon: "profile-icon",
                paths: [
                    ["/users", i18n.t("navbar.users")]
                ]
            },
            title: "users.createUserHeader"
        }
    },
    {
        path: "/users/edit/:userId",
        name: "editUser",
        component: () => import("@/components/users/_UserForm.vue"),
        props: true,
        meta: {
            breadcrumbs: {
                icon: "profile-icon",
                paths: [
                    ["/users", i18n.t("navbar.users")]
                ]
            }
        }
    },
    {
        path: "/Users/:id/ACL",
        name: "UsersACL",
        component: () => import("@/components/security/_AccessControl.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.GetAccessControlList,
            breadcrumbs: {
                icon: "profile-icon",
                paths: [
                    ["/users", i18n.t("navbar.users")]
                ]
            }
        },
        props: true
    }
];
